import { useQuery } from "@tanstack/react-query";
import { getStatistics } from "../services/api/statistics";

export const useStatistics = (type: string) => {
  return useQuery({
    queryKey: ['statistics', type],
    queryFn: () => getStatistics(type),
  })
}
